import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import {
  RiepilogoRiordino,
  RiepilogoRiordinoFisso,
} from 'src/app/models/riepilogo-riordino';
@Injectable({
  providedIn: 'root',
})
export class RiepilogoRiordinoService {
  private http = inject(HttpClient);
  edrUrl = environment.ildatoArticoliDpi + 'api/estrazionedatiriordino';

  getDettaglioCorrente(
    idCategoria = 0,
    idTipologia = 0,
    idSito = 0,
    idReparto = 0,
    idResponsabile = 0,
    idMansione = 0,
  ): Observable<any[]> {
    let filterString = '';
    if (idCategoria) {
      filterString += 'IdCategoria=' + idCategoria + '&';
    }
    if (idTipologia) {
      filterString += 'IdTipologia=' + idTipologia + '&';
    }
    if (idSito) {
      filterString += 'IdSito=' + idSito + '&';
    }
    if (idReparto) {
      filterString += 'IdReparto=' + idReparto + '&';
    }
    if (idResponsabile) {
      filterString += 'IdResponsabile=' + idResponsabile + '&';
    }
    if (idMansione) {
      filterString += 'IdMansione=' + idMansione + '&';
    }

    if (filterString.length > 0) {
      filterString = '?' + filterString.slice(0, -1).trim();
    }

    return this.http.get<any[]>(
      this.edrUrl + '/dettagliocorrente' + filterString,
    );
  }

  getRiepilogoAnnuale(
    anno: number,
    idCategoria = 0,
    idTipologia = 0,
    idSito = 0,
    idReparto = 0,
    idResponsabile = 0,
    idMansione = 0,
    // filtraZero = false,
  ): Observable<RiepilogoRiordino[]> {
    let filterString = '';
    if (idCategoria) {
      filterString += 'IdCategoria=' + idCategoria + '&';
    }
    if (idTipologia) {
      filterString += 'IdTipologia=' + idTipologia + '&';
    }
    if (idSito) {
      filterString += 'IdSito=' + idSito + '&';
    }
    if (idReparto) {
      filterString += 'IdReparto=' + idReparto + '&';
    }
    if (idResponsabile) {
      filterString += 'IdResponsabile=' + idResponsabile + '&';
    }
    if (idMansione) {
      filterString += 'IdMansione=' + idMansione + '&';
    }

    if (filterString.length > 0) {
      filterString = '?' + filterString.slice(0, -1).trim();
    }
    return this.http.get<RiepilogoRiordino[]>(
      this.edrUrl + '/riepilogoannuale/' + anno + filterString,
    );
  }

  getRiepilogoFisso(anno: number): Observable<RiepilogoRiordinoFisso> {
    return this.http.get<RiepilogoRiordinoFisso>(
      this.edrUrl + '/riepilogofisso/' + anno,
    );
  }
}
